import React, { Suspense } from 'react';
import MainLoading from './MainLoading/MainLoading';

const LoadingSuspense = ({ children }) => {
    return <Suspense fallback={<MainLoading />}>{children}</Suspense>
};

export default LoadingSuspense;